// global imports
import Vue from 'vue'
// import global components
import VueMaterial from 'vue-material'
import Snotify from 'vue-snotify'
import VTooltip from 'v-tooltip'
import VuejsDialog from 'vuejs-dialog'
import VueMoment from 'vue-moment'
import VueShortkey from 'vue-shortkey'
// app imports
import AppLayout from './app.layout.vue'
import router from './router'
import store from './store'
// import local components
import DataBox from './components/DataBox.vue'
// mixins imports
import currentUser from './mixins/currentUser'
import formatDateTime from './mixins/formatDateTime'
// styles imports
import 'vue-material/dist/vue-material.css'
import 'vue-snotify/styles/simple.scss'
import 'vue-datetime/dist/vue-datetime.css'
import './assets/fonts/bebasneue.css'
import './scss/style.scss'

// use global components
Vue.use(VueShortkey)
Vue.use(VueMoment)
Vue.use(VTooltip)
Vue.use(VueMaterial)
Vue.use(Snotify, {
  toast: {
    timeout: 10 * 1000,
    position: 'leftTop',
    showProgressBar: false
  }
})
Vue.use(VuejsDialog, {
  animation: 'fade',
  okText: 'ок',
  cancelText: 'сancel'
})
// use local components
Vue.component('UiDataBox', DataBox)
// use mixins
Vue.mixin(currentUser)
Vue.mixin(formatDateTime)

Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  name: 'Root',
  template: '<AppLayout/>',
  components: {AppLayout},
  el: '#app',
  router,
  store,

  mounted () {
    store.commit('SET_WINDOW_WIDTH', window.innerWidth)
    window.addEventListener('resize', () => store.commit('SET_WINDOW_WIDTH', window.innerWidth))
  },

  beforeDestroy () {
    window.removeEventListener('resize', () => store.commit('SET_WINDOW_WIDTH', window.innerWidth))
  }
})



// WEBPACK FOOTER //
// ./src/app.init.js